// ── Geolocation — real GPS coordinates + distance calc ───────────────────

// ── Request user location ─────────────────────────────────────────────────
export function requestLocation(onSuccess, onError) {
  if (!('geolocation' in navigator)) {
    onError?.('Geolocation not supported by your browser');
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (pos) => onSuccess?.({
      lat: pos.coords.latitude,
      lng: pos.coords.longitude,
      accuracy: pos.coords.accuracy,
    }),
    (err) => {
      const msgs = {
        1: 'Location access denied. Enable it in browser settings.',
        2: 'Location unavailable.',
        3: 'Location request timed out.',
      };
      onError?.(msgs[err.code] || 'Location error');
    },
    { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
  );
}

// ── Haversine distance (km) ───────────────────────────────────────────────
export function distanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) ** 2 +
            Math.cos(lat1 * Math.PI / 180) *
            Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng/2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

// ── Format distance for display ───────────────────────────────────────────
export function formatDistance(km, lang = 'en') {
  if (km < 1)   return lang === 'fr' ? 'À proximité' : 'Nearby';
  if (km < 1.5) return '1 km';
  if (km < 20)  return `${Math.round(km)} km`;
  if (km < 100) return `${Math.round(km / 5) * 5} km`;
  return lang === 'fr' ? 'Loin' : 'Far away';
}

// ── Attach distances to a user array ──────────────────────────────────────
export function attachDistances(users, myLat, myLng) {
  if (!myLat || !myLng) return users;
  return users.map(u => ({
    ...u,
    distance: u.lat && u.lng
      ? Math.round(distanceKm(myLat, myLng, u.lat, u.lng) * 10) / 10
      : u.distance || null,
  }));
}

// ── Cache location in localStorage (GPS coords — not user data, UI cache ok) ─
export function saveLocation(coords) {
  try {
    localStorage.setItem('beeloveLocation', JSON.stringify({
      ...coords, savedAt: Date.now()
    }));
  } catch {}
}

export function loadCachedLocation() {
  try {
    const d = JSON.parse(localStorage.getItem('beeloveLocation') || 'null');
    if (!d) return null;
    if (Date.now() - d.savedAt > 5 * 60 * 1000) return null; // stale after 5min
    return d;
  } catch { return null; }
}
